import * as Yup from 'yup';

export const validators = {
  username: (t) => Yup.string().trim()
    .required(t("Please Enter Username"))
    .min(3, t('min.field.characters', {count: 3}))
    .max(30, t("max.field.characters", {count: 30})),

  usernameOptional: (t) => Yup.string().trim()
    .transform((value) => (value === '' ? undefined : value)) // puste pole = brak nazwy, pomijamy min/max
    .min(3, t('min.field.characters', {count: 3}))
    .max(30, t("max.field.characters", {count: 30})),

  song: (t) => Yup.mixed().required(t('This field can\'t be empty'))
    .test("title-artist", t("Please Enter Song In Format Artist - Title"), (value) => {       // nie wymagamy
      const regex = /^\s*([\p{L}0-9&!?,.()\/']+(?:\s+[\p{L}0-9&!?,.()\/']+){0,9})\s{0,2}-\s{0,2}([\p{L}0-9&!?,.()\/']+(?:\s+[\p{L}0-9&!?,.()\/']+){0,9})\s*$/u;
      if (isNaN(+value) && !regex.test(value)) return false
      return true;
    })
    .test('min', t("Song must be at least 5 characters long"),
      (value) => {
        if (isNaN(+value) && value.length < 5) return false;
        return true;
      })
    .test('min', t("Song can have a maximum of 60 characters"),
      (value) => {
        if (isNaN(+value) && value.length > 60) return false;
        return true;
      }),

  user: (t) => Yup.object().required(t('This field can\'t be empty'))
    .test('min', t('Username must be at least 3 characters long'), (objectValue) => {
      if (objectValue.hasOwnProperty('__isNew__') && objectValue.__isNew__ === true && objectValue.value.length < 3) return false;
      return true
    })
    .test('max', t('Usernames can have a maximum of 30 characters'), (objectValue) => {
        if (objectValue.hasOwnProperty('__isNew__') && objectValue.__isNew__ === true && objectValue.value.length > 30) return false
        return true;
      }
    )
    .test('notNumber', t('Username can\'t be number'), (objectValue) => {
        if (objectValue.hasOwnProperty('__isNew__') && objectValue.__isNew__ === true && !isNaN(objectValue.value)) return false
        return true;
      }
    ),

  guestNote: (t) => Yup.string().min(2, t("Note must be at least 2 characters long"))
    .max(150, t("Note can have a maximum of 150 characters")),

  email: (t) =>
    Yup.string()
      .trim()
      .lowercase()
      .email(t("Invalid email format"))
      .min(7, t('At least 7 chars'))
      .max(40, t('Up to 40 chars'))
      .required(t("Please Enter Your Email")),

  password: (t) => Yup.string().trim()
    .min(8, t('Password must be at least 8 characters long'))
    .max(20, t('Password must be at most 20 characters long'))
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d\s])/,
      t('Password must contain at least one lowercase letter, one uppercase letter, one digit and one special character')
    ).required(t("Please Enter Password")),

  eventName: (t) => Yup.string().trim().required(t("Please Enter Name"))
    .min(3, t("Event must be at least 3 characters long"))
    .max(60, t("Event can have a maximum of 60 characters")),
};
